<div class="report-page-body-clip">
  <div class="report-page-body">
    @if (headerLogo(); as logo) {
      <div class="report-page-header"><img [src]="logo" alt="Logo" /></div>
    }
    <div class="report-page-content">
      <ng-content />
    </div>
    <div class="report-page-footer">
      <div class="d-flex justify-content-between w-100 align-items-center">
        <div>
          {{ translationKey('title') | translate }} - {{ portfolioTitle() }} -
          {{ currentDate | date: 'longDate' }}
        </div>
        <div class="report-page-number"></div>
      </div>
    </div>
    @if (chromeFooter(); as footerTpl) {
      <div class="report-page-chrome-footer d-print-none">
        <cfp-report-footer [showPoweredBy]="false" [printOnly]="false">
          <ng-container [ngTemplateOutlet]="footerTpl" />
        </cfp-report-footer>
      </div>
    }
  </div>
</div>
